import { Record } from 'immutable';

// NOTE: This type is not exhaustive. If any additional fields from the MPAC REST API
// are used, please add them to this type def.

export const makeMarketplaceAppFlatRatePricingItem = marketplaceAppPricingItem => marketplaceAppPricingItem;
export const makeMarketplaceAppPerUnitPricingItem = marketplaceAppPricingItem => marketplaceAppPricingItem;
export const makeMarketplaceAppPricing = Record({
  items: [],
  perUnitItems: undefined
});
const formatAppPricingItem = items => items.map(appPricingItem => ({
  monthsValid: appPricingItem.monthsValid,
  unitCount: appPricingItem.unitCount,
  amount: appPricingItem.localCurrencyAmount,
  currencyCode: appPricingItem.localCurrency
}));
export const makeMarketplaceAppPricingFromRawAppPricing = rawMarketplaceAppPricing => makeMarketplaceAppPricing({
  items: formatAppPricingItem(rawMarketplaceAppPricing.items),
  perUnitItems: formatAppPricingItem(rawMarketplaceAppPricing.perUnitItems || [])
});